import React from 'react';

function ChangeUser() {
  return (
    <div>ChangeUser</div>
  )
}

export default ChangeUser;